/**
 * The value of an `<input type="datetime-local">`, which the browser gives as
 * `YYYY-MM-DDTHH:mm`. Splitting it into the date and time halves the two
 * separate inputs bind to is reading a platform format, so it happens here.
 */
export function dateAndTimeParts(value: string): {
  date: string;
  time: string;
} {
  const [date = "", time = ""] = value.split("T");
  return { date, time };
}
